import React, { PureComponent } from 'react';
import {
  ComposedChart, Area, Bar, ReferenceLine, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer 
} from 'recharts';
import CriticalIcon from '@material-ui/icons/Warning';
import '../../styles/chart-styles.css';
import CustomizedLabel from './CustomizedLabel';
import ResponseTooltip from '../ResponseTooltip';
import TransferTooltip from '../TransferTooltip/TransferTooltip';
import * as utils from './utils'; 
import moment from 'moment';
import { access } from 'fs';

export default (props) => {
  const cutoff = props.alertCutoff;
  const { unit, times } = props;
  const data = utils.setData(props.scale, times, cutoff)
  const alerts = data.length > 0 
    ? data.reduce((acc, item) => {
      item.alert !== 0 ? acc.push(item) : null;
    return acc;
    }, [])
    : [];
  const alertRefLine = (time) => {
    return (
      <ReferenceLine yAxisId="left" x={time} stroke="#e91e63" strokeWidth={3}/>
    )
  }
  const setDomain = () => {
    const domain = [];
    if(data.length > 0) {
      domain[1] = data[data.length - 1].id;
      if(props.ticks) {
        if(props.ticks.length > 0) {
          if(props.ticks[0] < data[0].id) {
            domain[0] = props.ticks[0];
          } else domain[0] = data[0].id
        }
      }
    }
    return domain;
  }
  const domain = setDomain();
  const tickFormatter = (tick) => {
    const unixInMSecs = tick * 1000;
  const timezoneOffsetMSecs = new Date(unixInMSecs).getTimezoneOffset() * 60000;
  const day = new Date(unixInMSecs + timezoneOffsetMSecs).getTime()
  return moment(day).format("MMM DD");
  }
  
  return (
    <ResponsiveContainer width='100%' height={props.height}>
      <ComposedChart
  
        data={data}
        margin={{
          top: 0, right: 30, left: -10, bottom: 0,
        }}
      >
        <CartesianGrid vertical={false} stroke="#333333" />
        {props.panel === "card" 
          ?<XAxis dataKey="name" scale="point" />
          :<XAxis dataKey="id" interval={0} type="number" ticks={props.ticks} domain={setDomain()} tickFormatter={(tick) => {return tickFormatter(tick)}} />
        }
        <YAxis 
          allowDecimals={props.decimal} 
          yAxisId="left" 
          type="number" 
          dataKey="duration" 
          name="duration" 
          stroke={props.color} 
          scale={props.scale}
          domain={utils.setDomain(props.domainMin, props.domainMax)}
        />
        <Tooltip content={utils.setTooltip(props.transfer, props.panel)} />
        <ReferenceLine yAxisId="left" y={cutoff} label={<CustomizedLabel value={`${cutoff} ${unit}`}/>} stroke="#e91e63" strokeDasharray="3 3" />
        <ReferenceLine yAxisId="left" x={utils.setNewestValue(times)} stroke="white" isFront={true} />
        {props.panel === "details" && data.length > 0 ? alerts.map(item => { return alertRefLine(item.id)}) : null}
        <Area yAxisId="left" type="linear" dataKey="duration" unit={unit} stroke={props.color} fill={props.color} />
        {utils.setBar(props.transfer)}

      </ComposedChart>
    </ResponsiveContainer>
  );
}



// WEBPACK FOOTER //
// ./src/components/AreaChart/AreaChart.js